module.exports = __webpack_public_path__ + "img/quote_bg.9f9941d2.png";